import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { useOktaQuery, Team } from '../data';

const PlayerSelector = ({ isInAppSwitcher, teamid, player, onSelect, className, selectFirstOnLoad, position, showGenericLhhRhh, title }) => {
    const { t: translate } = useTranslation();
    const enabled = teamid != null;
    const [playerOptions, setPlayerOptions] = useState(null);
    const [processingPlayers, setProcessingPlayers] = useState(true);

    const processRosterToOptions = (data) => {
        const players = (data.sort((a, b) => (a.LastName > b.LastName ? 1 : -1))
            .map((x) => ({ ...x, name: x.FullName, value: x.PlayerID }))
            .filter((x) => (position !== 'pitcher' || x.IsPitcher)));

        if (selectFirstOnLoad && !player) {
            onSelect(players[0]);
        }

        if (showGenericLhhRhh) {
            const playerRhp = { PlayerID: 1, FullName: `${translate('baseball.abbr-versus')} ${translate('baseball.rhp')}`, Throws: 1, Bats: 0, name: `${translate('baseball.abbr-versus')} ${translate('baseball.rhp')}`, value: 1, isGenericHandednessPlayer: true };
            const playerLhp = { PlayerID: 2, FullName: `${translate('baseball.abbr-versus')} ${translate('baseball.lhp')}`, Throws: 2, Bats: 0, name: `${translate('baseball.abbr-versus')} ${translate('baseball.lhp')}`, value: 2, isGenericHandednessPlayer: true };
            setPlayerOptions([playerRhp, playerLhp, ...players]);
        } else {
            setPlayerOptions(players);
        }

        setProcessingPlayers(false);
    };

    const { data: options, status } = useOktaQuery(
        ['teamRoster', teamid],
        (te) => Team.loginroster(te, teamid),
        {
            enabled,
            onSuccess: (data) => { setProcessingPlayers(true); processRosterToOptions(data); },
        },
    );

    useEffect(() => {
        if (teamid && !isInAppSwitcher) {
            // onSelect(null);
        }
    }, [isInAppSwitcher, teamid, onSelect]);

    if (status === 'loading' || processingPlayers) {
        return <LoadingSpinner border="animation" className="float-end" />;
    }

    if (!options) {
        return <span className="float-end" style={{ fontStyle: 'italic' }}><br />{translate('common.select-a-team')}</span>;
    }

    return (
        playerOptions?.length > 0 && (
            <Dropdown
                align="end"
                options={playerOptions}
                value={player}
                title={title || translate('common.select-a-player')}
                onSelect={onSelect}
                className={className}
            />
        )
    );
};

PlayerSelector.defaultProps = {
    isInAppSwitcher: false,
    teamid: undefined,
    player: undefined,
    className: '',
    selectFirstOnLoad: false,
    position: 'all',
    showGenericLhhRhh: false,
    title: undefined,
};

PlayerSelector.propTypes = {
    isInAppSwitcher: PropTypes.bool,
    teamid: PropTypes.number,
    player: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({ name: PropTypes.string.isRequired, value: PropTypes.number }),
    ]),
    onSelect: PropTypes.func.isRequired,
    className: PropTypes.string,
    selectFirstOnLoad: PropTypes.bool,
    position: PropTypes.string,
    showGenericLhhRhh: PropTypes.bool,
    title: PropTypes.string,
};

export default PlayerSelector;
